// extracted by mini-css-extract-plugin
export default {"wrapper":"tech-box_wrapper__GLaPn","boxText":"tech-box_boxText__-o2tK"};